import { TextLinkKind, TextLinkWidget } from '@tableau/widgets';
import { BodyCell } from '@tableau/widgets-datagrid';
import * as React from 'react';
import _ = require('underscore');

import { style } from 'typestyle';

import { StyledCellFormatter } from '~src/app/spaces/ListView/StyledCellWrapper';
import { Messages } from '~src/codegen/Localize';
import { CommonStyles } from '~src/common/react/CommonStyles';
import { getAndOpenLinkedTaskDetailsDialog } from '~src/linkedTasks/components/LinkedTaskDetailsDialog';
import { RunFlowTaskInfo } from '~src/ts/models/RunFlowTaskInfo';

import { SpacesSiteUrls } from '../../SpacesSiteUrls';
import { ILink } from './LinkCell';

export function RunFlowTaskCell(urls?: SpacesSiteUrls): React.FunctionComponent<BodyCell.Props> {
  const iconClassName = 'tb-grid-icon-flow';
  const runFlowTaskCellStyle = style({
    display: 'block',
    fontWeight: 'normal',
    ...CommonStyles.Layout.TextEllipsis
  });
  return StyledCellFormatter(
    function RunFlowTaskCell(props: BodyCell.Props) {
      const data: RunFlowTaskInfo = props.row.data as RunFlowTaskInfo;
      const isLinkedTask: boolean = data.taskType === 'LinkedTask';
      const isFlowTask: boolean = data.taskType === 'FlowTask';

      let Icon = () =>
        <span data-tb-test-id={'data-grid-cell-icon'}
          className={iconClassName}
          title={Messages.flow()}
          style={{ flex: 'none' }} />;

      function handleLinkedTaskWithCountClick() {
        getAndOpenLinkedTaskDetailsDialog(data.linkedTaskId);
      }

      if (isLinkedTask) {
        return (
          <div style={CommonStyles.Layout.FlexBlockLeftAndCenter}>
            {<Icon />}
            <TextLinkWidget
              testId={'LinkedTaskScheduleTypeCellTextLinkButton'}
              className={runFlowTaskCellStyle}
              onClick={handleLinkedTaskWithCountClick}
            >
              {Messages.linkedTasksWithFormattedCount({ TOTAL_COUNT_LOC: data.totalSteps.toString() })}
            </TextLinkWidget>
          </div>
        );
      } else if (isFlowTask) {
        const link: ILink = {
          text: data.flow.name,
          url: urls.forSiteName(data.site.urlName).flowUrl(data.flow.id),
          iconClassName: iconClassName,
          iconTitle: Messages.flow()
        };
        return (
          <div className={style(CommonStyles.Layout.FlexBlockLeftAndCenter)}>
            {<Icon />}
            <TextLinkWidget
              testId={'FlowScheduleTypeCellTextLinkButton'}
              className={runFlowTaskCellStyle}
              href={link.url}
              kind={TextLinkKind.Standard}
            >
              {link.text}
            </TextLinkWidget>
          </div>
        );
      }

    }
  );
}
